/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DisciplineClassesViewModel } from "../types/DisciplineClassesViewModel.ts";
import { disciplineClassItemViewModelSchema } from "./disciplineClassItemViewModelSchema.ts";

export const disciplineClassesViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  discipline: z.string().nullish(),
  firstClassDate: z.string().date().nullish(),
  lastClassDate: z.string().date().nullish(),
  classes: z.array(z.lazy(() => disciplineClassItemViewModelSchema)).nullish(),
}) as unknown as ToZod<DisciplineClassesViewModel>;
